module.exports = {"id":"231747","name":"Kylian Mbappé","rating":"84","photo":"./data/images/photos/4/231747.png","club":{"name":"Paris","logo":"./data/images/clubs/Paris.png"},"positions":["BU","AD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KylianMbappe0.json
// module id = 2416
// module chunks = 0